import * as React from "react"

const MOBILE_BREAKPOINT = 768

export function useIsMobile() {
  // 始终以 false 初始化，确保服务端和客户端初始值一致
  const [isMobile, setIsMobile] = React.useState(false)

  React.useEffect(() => {
    // 检测是否为触摸设备（包括 iPad）
    const isTouchDevice = 'ontouchstart' in window || 
                         navigator.maxTouchPoints > 0 ||
                         !!navigator.userAgent.match(/iPad/i) ||
                         (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    
    // 小屏幕或触摸设备都使用移动端交互
    const mql = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`)
    const onChange = () => {
      const isSmallScreen = window.innerWidth < MOBILE_BREAKPOINT
      setIsMobile(isSmallScreen || isTouchDevice)
    }
    
    mql.addEventListener("change", onChange)
    // 立即设置正确的值
    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT || isTouchDevice)
    
    return () => mql.removeEventListener("change", onChange)
  }, [])

  return isMobile
}
